var AssetApplicationSubType;
(function (AssetApplicationSubType) {
  // .pdf
  AssetApplicationSubType["pdf"] = "pdf";
  // .doc
  AssetApplicationSubType["msword"] = "msword";
  // .docx
  AssetApplicationSubType["vnd.openxmlformats-officedocument.wordprocessingml.document"] = "vnd.openxmlformats-officedocument.wordprocessingml.document";
  // .xls
  AssetApplicationSubType["vnd.ms-excel"] = "vnd.ms-excel";
  // .xlsm
  AssetApplicationSubType["vnd.ms-excel.sheet.macroenabled.12"] = "vnd.ms-excel.sheet.macroenabled.12";
  // .xlsx
  AssetApplicationSubType["vnd.openxmlformats-officedocument.spreadsheetml.sheet"] = "vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  // .ppt
  AssetApplicationSubType["vnd.ms-powerpoint"] = "vnd.ms-powerpoint";
  // .pptx
  AssetApplicationSubType["vnd.openxmlformats-officedocument.presentationml.presentation"] = "vnd.openxmlformats-officedocument.presentationml.presentation";
  // .pages
  AssetApplicationSubType["vnd.apple.pages"] = "vnd.apple.pages";
  // .gdoc
  AssetApplicationSubType["vnd.google-apps.document"] = "vnd.google-apps.document";
  // .gslides
  AssetApplicationSubType["vnd.google-apps.presentation"] = "vnd.google-apps.presentation";
  // .gsheets
  AssetApplicationSubType["vnd.google-apps.spreadsheet"] = "vnd.google-apps.spreadsheet";
  // .zip
  AssetApplicationSubType["x-zip-compressed"] = "x-zip-compressed";
  // .octet-stream
  AssetApplicationSubType["octet-stream"] = "octet-stream";
  // .epub+zip
  AssetApplicationSubType["epub+zip"] = "epub+zip";
  // .txt
  AssetApplicationSubType["txt"] = "txt";
  // .docx
  AssetApplicationSubType["docx"] = "docx";
  // .xltx
  AssetApplicationSubType["xltx"] = "xltx";
  // .x-msdownload
  AssetApplicationSubType["x-msdownload"] = "x-msdownload";
  // .vnd.android.package-archive
  AssetApplicationSubType["vnd.android.package-archive"] = "vnd.android.package-archive";
  // .rar
  AssetApplicationSubType["rar"] = "rar";
  AssetApplicationSubType["vnd.rar"] = "vnd.rar";
  AssetApplicationSubType["x-rar-compressed"] = "x-rar-compressed";
  // .zip
  AssetApplicationSubType["zip"] = "zip";
})(AssetApplicationSubType || (AssetApplicationSubType = {}));
var AssetImageSubType;
(function (AssetImageSubType) {
  // .png
  AssetImageSubType["png"] = "png";
  // .gif
  AssetImageSubType["gif"] = "gif";
  // .jpeg
  AssetImageSubType["jpeg"] = "jpeg";
  // .jpg
  AssetImageSubType["jpg"] = "jpg";
  // .webp
  AssetImageSubType["webp"] = "webp";
  // .bmp
  AssetImageSubType["bmp"] = "bmp";
  // .svg
  AssetImageSubType["svg+xml"] = "svg+xml";
  // .psd
  AssetImageSubType["vnd.adobe.photoshop"] = "vnd.adobe.photoshop";
  // .psd
  AssetImageSubType["psd"] = "psd";
  // .dng
  AssetImageSubType["x-adobe-dng"] = "x-adobe-dng";
  AssetImageSubType["dng"] = "dng";
})(AssetImageSubType || (AssetImageSubType = {}));
var AssetVideoSubType;
(function (AssetVideoSubType) {
  AssetVideoSubType["*"] = "*";
  AssetVideoSubType["mp4"] = "mp4";
  AssetVideoSubType["avi"] = "avi";
  AssetVideoSubType["webm"] = "webm";
  AssetVideoSubType["ogg"] = "ogg";
  AssetVideoSubType["quicktime"] = "quicktime";
  AssetVideoSubType["mpeg"] = "mpeg";
  AssetVideoSubType["x-matroska"] = "x-matroska";
  AssetVideoSubType["mkv"] = "mkv";
})(AssetVideoSubType || (AssetVideoSubType = {}));
var AudioSubType;
(function (AudioSubType) {
  // .mp3
  AudioSubType["mp3"] = "mp3";
  // .wav
  AudioSubType["wav"] = "wav";
  // .ogg
  AudioSubType["ogg"] = "ogg";
  // .mpeg / .mp3
  AudioSubType["mpeg"] = "mpeg";
  // .mid / .mid
  AudioSubType["mid"] = "mid";
  // .midi / .midi
  AudioSubType["x-midi"] = "x-midi";
  // .opus
  AudioSubType["opus"] = "opus";
  // .weba
  AudioSubType["weba"] = "webm";
  // .3gp
  AudioSubType["3gpp"] = "3gpp";
  // .3g2
  AudioSubType["3gpp2"] = "3gpp2";
  // .aac
  AudioSubType["aac"] = "aac";
})(AudioSubType || (AudioSubType = {}));

export { AssetApplicationSubType, AssetImageSubType, AssetVideoSubType, AudioSubType };
